export function convertPositiveNumber(value: string, maxValue: number) {
  const currValue = Number(value.replace(/\D/g, ''));
  if (value === '') {
    return '';
  }
  if (currValue < 1) {
    return 1;
  }
  if (currValue > maxValue) {
    return maxValue;
  }
  return currValue;
}

export function masterPinFormatting(value: string) {
  const currValue = value.replace(/\D/g, '');

  if (value.length > 4) {
    return value.slice(0, 4);
  }
  return currValue;
}

export const scrollToTop = () => {
  const contentWrap = document.querySelector('.content-wrap');
  if (contentWrap) {
    contentWrap.scrollTo({ top: 0, behavior: 'smooth' });
  }
};
